import { Vessel } from '@navstation-portal/vessels/data-model/vessel';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

export const appEvents = eventGroup({
  source: 'AppStore',
  events: {
    setSelectedVesselId: type<string>(),
    setDefaultVesselId: type<string>(),
    setSelectedVessel: type<Vessel>(),
    reset: type<void>(),
    setLoadingFullOverlay: type<boolean>(),
  },
});
